import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { coreService } from 'network-utils';
import { SmallLoader } from 'learning-panel-components';
import { selectToken } from '@redux/slices/userSlice';
import { useGetChallengeTeamsLeaderboard } from '@queries/core/challenges';
import TeamLeaderboard from './playTeamLeaderboard';
import { TeamData } from '../leaderboard/challengeTeamLeaderboard';
import styles from './playLeaderboardLoader.module.scss';

const TeamLeaderboardContainer: FC = () => {
    const token = useSelector(selectToken);
    const [allTeams, setAllTeams] = useState<TeamData[]>([]);
    const [isFetchingData, setIsFetchingData] = useState<boolean>(false);
    const [myTeams, setMyTeams] = useState<TeamData[]>([]);
    const [teamsUsersDataOpen, setTeamsUsersDataOpen] = useState<{ [teamUuid: string]: boolean }>({});
    const { data, isLoading } = useGetChallengeTeamsLeaderboard(token);

    const mapTeams = (teams: coreService.TeamLeaderboard[]): TeamData[] => {
        return teams.map((team: coreService.TeamLeaderboard) => ({
            uuid: team.uuid,
            rank: team.rank,
            teamName: team.name,
            score: Number(team.points),
            profilePicture: '',
            teamMembers: team.membersCount,
            usersCount: team.usersCount
        }));
    };

    useEffect(() => {
        if (!data?.teamsLeaderboard) return;
        setIsFetchingData(true);
        const { myTeams, allTeams } = data.teamsLeaderboard;
        setMyTeams(mapTeams(myTeams));
        setAllTeams(mapTeams(allTeams));
        setIsFetchingData(false);
    }, [data]);

    const onChangeOpenMode = (teamUuid: string, teamType: string) => {
        const myTeamsOpenDataTemp = { ...teamsUsersDataOpen };
        myTeamsOpenDataTemp[`${teamUuid}-${teamType}`] = !(
            Object.prototype.hasOwnProperty.call(myTeamsOpenDataTemp, `${teamUuid}-${teamType}`) &&
            myTeamsOpenDataTemp[`${teamUuid}-${teamType}`]
        );
        setTeamsUsersDataOpen({ ...myTeamsOpenDataTemp });
    };

    return isLoading || isFetchingData || !allTeams ? (
        <div className={styles.loader}>
            <SmallLoader size="100px" />
        </div>
    ) : (
        allTeams && (
            <TeamLeaderboard
                onLoadMore={() => undefined}
                hasMore={false}
                teams={allTeams}
                myTeams={myTeams}
                onChangeOpenMode={onChangeOpenMode}
                teamsUsersOpenState={teamsUsersDataOpen}
            />
        )
    );
};

export default TeamLeaderboardContainer;
